import { ComponentType, ReactElement } from 'react';

export function makeReactProvider(fn: (Component: ComponentType) => ReactElement) {
  return (Component: ComponentType) => () => fn(Component);
}
